<template>
  <div class="typeahead">
    <font-awesome-icon
      v-if="loading"
      class="typeahead__loading"
      :icon="['far', 'circle-notch']"
      spin
    />

    <!-- the input field -->
    <input
      v-model="query"
      type="text"
      maxlength="5"
      placeholder="รหัสไปรษณีย์"
      autocomplete="off"
      class="form-control"
      @keydown.down="down"
      @keydown.up="up"
      @keydown.enter="hit"
      @input="onTextInput"
    >

    <!-- the list -->
    <ul
      v-show="hasItems"
      class="typeahead__list"
    >
      <!-- for vue@1.0 use: ($item, item) -->
      <li
        v-for="(item, $item) in items"
        :key="item.id"
        :class="activeClass($item)"
        @mousedown="hit"
        @mousemove="setActive($item)"
      >
        {{ item.amphure.province.name_th }} &#187; {{ item.amphure.name_th }} &#187; {{ item.name_th }} &#187; {{ item.zip_code }}
      </li>
    </ul>
  </div>
</template>

<script>
import VueTypeahead from 'vue-typeahead';

export default {
  extends: VueTypeahead,
  props: {
    value: {
      type: String,
      default: '',
      required: true,
    },
  },
  data() {
    return {
      query: '',
      src: '/area/search',
      limit: 100,
      minChars: 2,
      selectFirst: true,
    };
  },

  mounted() {
    setTimeout(() => {
      this.query = this.value;
    }, 200);
  },

  methods: {
    // The callback function which is triggered when the user hits on an item
    // (required)
    onTextInput() {
      this.$emit('change', this.query);
      this.update();
    },
    onHit(item) {
      // alert(item)
      this.$emit('selected', item);
      this.query = item.zip_code;
      this.items = [];
    },

    // The callback function which is triggered when the response data are received
    // (optional)
    prepareResponseData(data) {
      // data = ...
      return data;
    },
  },
};
</script>
